// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"c6f25ff3","633":"6a1c98f9","816":"403e8a02"}[chunkId] + ".chunk.js";
};